import { GithubSyncDialogData } from '@mode/github/contract';
import { createAction, props } from '@ngrx/store';

export const githubSyncDialogChangesPushed = createAction(
  '[Github Sync Dialog] Changes Pushed',
  props<{ dialogData: GithubSyncDialogData; commitMessage: string }>()
);

export const githubSyncDialogPushSucceeded = createAction('[Github Sync Dialog] Push Succeeded');

export const githubSyncDialogPushFailed = createAction('[Github Sync Dialog] Push Failed', props<{ error: any }>());
